import { BooleanInput, TextInput, ValidateForm } from "react-admin";

import {
  AUTH0_CONNECTION_NAME_TOOLTIP_TEXT,
  SSO_INFO_NOTES_MAX_LENGTH,
} from "../../constants";
import { DataKind, SsoInfoResponse } from "../../types";
import validators from "../../utils/Validators";
import {
  CustomCreate,
  CustomNumberInput,
  LabelWithInfoTooltip,
} from "../custom";

function SsoInfoCreate() {
  const transform = ({ is_enabled, ...data }: Partial<SsoInfoResponse>) => data;

  const validateForm: ValidateForm = (values: any) =>
    validators.validateAuth0ConnectionName(values.auth0_connection_name);

  return (
    <CustomCreate
      checkPermissionFor={DataKind.SsoInfo}
      transform={transform}
      validate={validateForm}
    >
      <CustomNumberInput label="Account ID" source="account_id" required />
      <TextInput label="Domain" source="domain" required />
      <TextInput
        label={
          <LabelWithInfoTooltip
            labelText="Auth0 Connection Name"
            tooltipText={AUTH0_CONNECTION_NAME_TOOLTIP_TEXT}
          />
        }
        source="auth0_connection_name"
        required
      />
      <TextInput
        label="Notes"
        source="notes"
        multiline
        minRows={3}
        fullWidth
        inputProps={{ maxLength: SSO_INFO_NOTES_MAX_LENGTH }}
      />
      <BooleanInput
        label="Is Enabled"
        source="is_enabled"
        defaultValue={false}
        disabled
        helperText="SSO infos are created disabled. Use Enable on the detail page."
      />
    </CustomCreate>
  );
}

export default SsoInfoCreate;
